import { config } from '~app/config';

import { ResponseSuccess } from '@breezeventures/scp-client';
import { makeRequest } from '@breezeventures/web-lib-ph-request/make-request';
import { skipToken, useQuery, UseQueryOptions } from '@tanstack/react-query';

import { partnerApplicationKeys } from './partner-application-keys';

import type { PartnerApplicationResponse } from '../model';

type GetPartnerApplicationByIdRequest = {
  applicationId: string | undefined;
};

export const usePartnerApplicationById = (
  data: GetPartnerApplicationByIdRequest,
  options?: UseQueryOptions<PartnerApplicationResponse>
) => {
  return useQuery({
    queryKey: partnerApplicationKeys.byId(data.applicationId),
    queryFn: data.applicationId
      ? () => {
          return makeRequest<ResponseSuccess<PartnerApplicationResponse>>({
            url: `${config.apiHost}/merchant-origination/api/v1/public/partner/applications/get-by-id`,
            credentials: 'include',
            payload: data,
          }).then((response) => response.payload);
        }
      : skipToken,
    gcTime: 0,
    ...options,
  });
};
